import * as redux from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import createDataDogMiddleware from '../common/logging/datadog';

export const getProdMiddlewares = () => {
    const env = 'production';
    if (!env) {
        return []
    }

    const dataDogMiddleware = createDataDogMiddleware(
        env,
        window.amplify_lantern_config.version
    );
    return [
        dataDogMiddleware
    ];
};


export const createStore = (rootReducer, initialState, middlewares) => {
    return redux.createStore(rootReducer, initialState,
        composeWithDevTools(redux.applyMiddleware(...middlewares)));
}
